(function () {
    "use strict";

    angular
        .module('harriApp')
        .controller("ManageTagsModalController", ManageTagsModalController);

    ManageTagsModalController.$inject = ["$scope", "modalData", "tagsDataService", "onClose"];

    function ManageTagsModalController ($scope, modalData, tagsDataService, onClose) {
        const self = this;
        let originalTags = [];

        let init = () => {
            self.tags = modalData.tags;
            self.tagsType = modalData.tagsType;
            self.brandId = modalData.brandId;
            originalTags = angular.copy(self.tags);
        }

        self.canMove = (currentIndex, targetIndex) => {
            if (
                currentIndex < 0 || currentIndex >= self.tags.length ||
                targetIndex < 0 || targetIndex >= self.tags.length
            ) {
                return false;
            }
            return true;
        };

        self.onDragEnd = ({oldIndex, newIndex}) => {
            if (newIndex === oldIndex || !self.canMove(oldIndex, newIndex)) {
                return;
            }

            const [movedTag] = self.tags.splice(oldIndex, 1);
            self.tags.splice(newIndex, 0, movedTag);
            $scope.$digest();
        };

        init();

        self.close = () => {
            self.tags = angular.copy(originalTags);
            onClose?.(self.tags);
            $scope.$hide();
        };

        self.save = async () => {
            self.isLoading = true;
            const payload = self.tags.map((tag, index) => ({
                brand_tag_id: tag.id,
                sort_order: index + 1
            }));

            try {
                const res = await tagsDataService.manageTagsOrder(self.brandId, self.tagsType, payload);
                onClose?.(self.tags);
                $scope.$hide();
                return res;
            } catch (err) {
                console.log(err);
                throw err;
            } finally {
                self.isLoading = false;
                $scope.$digest();
            }
        };
    }
})();
